/** Monta o link wa.me; assume DDI 55 (Brasil) quando o número vem só com DDD. */
export function montarLinkWhatsapp(numero: string, referencia?: string): string {
  const texto = referencia
    ? `Olá! Gostaria de confirmar meu pedido #${referencia}.`
    : 'Olá! Gostaria de saber sobre o meu pedido.';
  return montarLinkWhatsappComTexto(numero, texto);
}

/** Mesmo link, com a mensagem pronta — para avisos que não são sobre um pedido já feito. */
export function montarLinkWhatsappComTexto(numero: string, texto: string): string {
  const digitos = numero.replace(/\D/g, '');
  const comDDI = digitos.length <= 11 ? `55${digitos}` : digitos;
  return `https://wa.me/${comDDI}?text=${encodeURIComponent(texto)}`;
}

/** Normaliza o Instagram (@usuário, usuário ou URL) para um link de perfil. */
export function montarLinkInstagram(valor: string): string {
  const v = valor.trim();
  if (/^https?:\/\//i.test(v)) return v;
  return `https://instagram.com/${v.replace(/^@/, '')}`;
}
